import React from "react";
import { HandHeart, Users, Lightbulb } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const benefits = [{
  title: "Elevate Family Narratives",
  description: "By partnering with us, you help bring the authentic voices of families to the forefront, ensuring their lived experiences guide meaningful improvements in pediatric care and support.",
  icon: HandHeart
}, {
  title: "Bridge Clinical Empathy",
  description: "We connect medical expertise with human storytelling, providing clinicians and specialists with the deep insights needed to deliver more compassionate, patient-centered healthcare.",
  icon: Users
}, {
  title: "Expand Community Hope",
  description: "Together, we develop innovative resources and platforms that empower caregivers with the knowledge and connection they need to navigate their child's complex health journey.",
  icon: Lightbulb
}];
export default function BenefitsOfPartnering() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="51881" id="partner-benefits" ref={ref} className={cn("bg-background py-[160px] relative overflow-hidden transition-opacity duration-1000", isVisible ? "opacity-100" : "opacity-0")}>
      <div className="container mx-auto px-6 md:px-12">
        

        
      </div>
    </section>;
}